import { render, staticRenderFns } from "./starRight.vue?vue&type=template&id=c546c76a&scoped=true"
import script from "./starRight.vue?vue&type=script&lang=js"
export * from "./starRight.vue?vue&type=script&lang=js"
import style0 from "./starRight.vue?vue&type=style&index=0&id=c546c76a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c546c76a",
  null
  
)

export default component.exports